import request from './adminRequest'

export const groupApi = {
  listGroup(params) {
    return request.get('/listGroup', {params: params})
  },
  createGroup (data) {
    return request.post('/createGroup', data)
  },
  updateGroup (data) {
    return request.post('/updateGroup', data)
  },
  updateGroupSortNum (id, data) {
    return request.post('/updateGroupSortNum/' + id, data)
  },
  getGroupInfo (id) {
    return request.get('/groups/' + id)
  },
  listChannel (groupId, params) {
    return request.get('/' + groupId + '/listChannel', {params: params})
  },
  createChannel (data) {
    return request.post('/createChannel', data)
  },
  updateChannel (data) {
    return request.post('/updateChannel', data)
  },
  updateChannelSortNum (id, data) {
    return request.post('/updateChannelSortNum/' + id, data)
  },
  deleteChannel (id) {
    return request.delete('/channels/' + id)
  },
  getChannelInfo (id) {
    return request.get('/channels/' + id)
  },
  listChannelMembers (params) {
    return request.get('/channels/listMembers', { params: params })
  },
  listGroupUserSimpleInfo (groupId) {
    return request.get('/' + groupId + '/listUserSimpleInfo')
  },
  joinChannel (data) {
    return request.post('/joinChannel', data)
  },
  joinGroup (data) {
    return request.post('/joinGroup', data)
  },
  kickOutChannel (data) {
    return request.post('/kickOutChannel', data)
  },
  kickOutGroup (data) {
    return request.post('/kickOutGroup', data)
  },
  forbidSendMsg (data) {
    return request.post('/forbidSendMsg', data)
  },
  updateMemberRole (data) {
    return request.post('/updateGroupMemberRole', data)
  },
  getChannelMsg (data) {
    return request.post('/getChannelMsg', data)
  },
  listChannelMessage (params) {
    return request.get('/listChannelMessage', { params: params })
  },
  listPrivateMessage (params) {
    return request.get('/listPrivateMessage', {params: params})
  },
  deleteChannelMessage (data) {
    return request.put('/deleteChannelMessage', data)
  },
  listPrivateGroup (data) {
    return request.post('/listPrivateGroup', data)
  },
  listC2cGroup (data) {
    return request.post('/listC2cGroup', data)
  },
  listPost (groupId) {
    return request.get('/' + groupId + '/listGroupPost')
  },
  createGroupPost (data) {
    return request.post('/createGroupPost', data)
  },
  updateGroupPost (data) {
    return request.post('/updateGroupPost', data)
  },
  getGroupPost (postId) {
    return request.get('/' + postId + '/getGroupPostInfo')
  },
  destroyGroup (param) {
    return request.delete('/destroyGroup', { params: param })
  },
}

export default groupApi
